import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { CrudService } from "src/app/services/crud.service";

@Component({
    selector: "app-kitchen-types",
    templateUrl: "./kitchen-types.component.html",
    styleUrls: ["./kitchen-types.component.scss"],
    standalone: false
})
export class KitchenTypesComponents implements OnInit {
  constructor(private crud: CrudService) {
    this.crud.getData("restaurante/tipos-cozinha").subscribe((response) => {
      this.listKitchens = response["data"];
    });
  }

  listKitchens = [];
  @Input() controlForm: UntypedFormGroup;
  @Output() emitterKitchenSelected = new EventEmitter();
  @ViewChild("slide", { static: true }) slides: any;
  selectedItem: any;

  slideOpts = {
    initialSlide: 0,
    slidesPerView: 3,
    pager: true,
    speed: 400,
    watchSlidesProgress: true,
    loop: false,
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      dynamicBullets: true,
      dynamicMainBullets: 3,
    },
  };

  ngOnInit() {}

  selectItem(index, item) {
    this.selectedItem = index;
    this.emitterKitchenSelected.emit(item);
  }

  sortBy(prop: string) {
    return this.listKitchens.sort((a, b) =>
      a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1,
    );
  }
}
